var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-tooltip',{attrs:{"right":"","fixed":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('p',{staticClass:"caption text-right"},[_c('span',_vm._g({},on),[_vm._v(" "+_vm._s(_vm.timeString)+" ")])])]}}])},[_c('span',[_vm._v(_vm._s(_vm.timeTooltip))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }